export const beth_addr = process.env.VUE_APP_BETH_URL;
